import { customerEstelleImage } from "@/lib/gcsImagePaths";
import { testimonialEstelleOriginal } from "@/lib/gcsImagePaths";
import { testimonialMichael } from "@/lib/gcsImagePaths";
import { testimonialSontice, testimonialDebbie } from "@/lib/gcsImagePaths";
import { CarouselWithPath } from "@/types/carousel";

export const carouselImages = [
  {
    src: testimonialSontice,
    alt: "Happy family protected by Guardian Service",
    name: "Sontice",
    amount: "$1,847",
    description: "with the exact same coverage",
  },
  {
    src: testimonialMichael,
    alt: "Couple enjoying savings with Guardian Service",
    name: "Michael",
    amount: "$3,337",
    description:
      "and increased his home replacement cost and auto liability coverage",
  },
  {
    src: testimonialEstelleOriginal,
    alt: "Estelle enjoying savings with Guardian Service",
    name: "Estelle",
    amount: "$658",
    description: "and realized she was underinsured by $8,800",
  },
  {
    src: testimonialDebbie,
    alt: "Debbie enjoying savings with Guardian Service",
    name: "Debbie",
    amount: "$3,651",
    description: " with the exact same coverage",
    objectPositionClass: "object-[center_78%] md:object-[center_70%]",
  },
];

export const oPayCarouselImages: CarouselWithPath[] = [
  {
    path: testimonialSontice,
    alt: "Happy family protected by Guardian Service",
    name: "Sontice",
    amount: "$1,847",
    description: "with the exact same coverage",
  },
  {
    path: testimonialMichael,
    alt: "Couple enjoying savings with Guardian Service",
    name: "Michael",
    amount: "$3,337",
    description:
      "and increased his home replacement cost and auto liability coverage",
  },
  {
    path: customerEstelleImage,
    alt: "Estelle enjoying savings with Guardian Service",
    name: "Estelle",
    amount: "$658",
    description: "and realized she was underinsured by $8,800",
  },
  {
    path: testimonialDebbie,
    alt: "Debbie enjoying savings",
    name: "Debbie",
    amount: "$3,651",
    description: "with the exact same coverage",
  },
];
